import React, { useEffect } from "react";

import Hero from "components/Hero";
import StoriaRabar from "components/StoriaRabar";
import Piatti from "components/Piatti";
import MenuColazione from "components/MenuColazione";
import MenuAperitivo from "components/MenuAperitivo";
import EventiRabar from "components/EventiRabar";

import logo from "images/bi/logo_rabar.png";
import video from "video/rabarbaro_rabar-orizzontale.mp4";

import { immagini_rabar } from "site-structure";

const Rabar = ({ title }) => {
	useEffect(() => {
		document.title = title;
	}, [title]);

	return (
		<>
			<Hero
				video={video}
				overtitle={"Fioreria di colazioni e aperitivi"}
				logo={logo}
				cta={false}
			/>

			<div className="main">
				<StoriaRabar />

				<Piatti
					overtitle="Foto di repertorio"
					title="Completamente a caso"
					gallery={immagini_rabar}
				/>

				<MenuColazione />

				<MenuAperitivo />

				<EventiRabar />
			</div>
		</>
	);
};

export default Rabar;
